/**
 * @file Frontend module — config/apiConfig.ts. Default API base used when `REACT_APP_API_BASE_URL` is unset (matches axios clients). */

export const DEFAULT_API_BASE_URL = "http://localhost:5050/api";

/** Runtime API base URL from env with the same fallback as axios clients. */
export function getApiBaseUrl(): string {
  const fromEnv = String(process.env.REACT_APP_API_BASE_URL ?? "").trim();
  return fromEnv || DEFAULT_API_BASE_URL;
}

/** Origin for static uploads (`/uploads/...`) derived from the API base URL. */
export function getUploadOrigin(apiBaseUrl?: string | null): string {
  const base = (apiBaseUrl && String(apiBaseUrl).trim()) || getApiBaseUrl();
  const origin = base.replace(/\/api\/?$/i, "").replace(/\/+$/, "");
  return origin || DEFAULT_API_BASE_URL.replace(/\/api\/?$/i, "");
}
